export class LogSourceLocationSplunkDdss {
    'prefix';
    'indexName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "indexName",
            "baseName": "indexName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogSourceLocationSplunkDdss.attributeTypeMap;
    }
    constructor() {
    }
}
